import leftImage from "../../assest/blueArrow.png";
import rightImage from "../../assest/blackSquares.jpg";
import { motion } from "framer-motion";

const Minibanners = () => {
  // Animation variants for the boxes and text
  const boxVariants = {
    hidden: { opacity: 0, x: -100 }, // Initial position for the left-side div (hidden, moved to the left)
    visible: { opacity: 1, x: 0, transition: { duration: 2 } }, // Slower transition (duration: 2s)
  };

  const boxRightVariants = {
    hidden: { opacity: 0, x: 100 }, // Initial position for the right-side div (hidden, moved to the right)
    visible: { opacity: 1, x: 0, transition: { duration: 2 } }, // Slower transition (duration: 2s)
  };

  const textVariants = {
    hidden: { opacity: 0, y: 20 }, // Text starts from below
    visible: { opacity: 1, y: 0, transition: { duration: 1.5 } }, // Text comes to its normal position
  };

  return (
    <div className="minibanner">
      <motion.div
        className="left-banner"
        variants={boxVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <motion.img
          src={leftImage}
          alt="img"
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 2, ease: "easeInOut" }}
        />
        <motion.div
          className="box1"
          variants={textVariants}
          initial="hidden"
          whileInView="visible" // Scroll-triggered animation
          viewport={{ once: true }}
        >
          <h2>Create a New Event</h2>
          <h3>Organize & Manage using the latest features</h3>
        </motion.div>
      </motion.div>

      <motion.div
        className="right-banner"
        variants={boxRightVariants}
        initial="hidden"
        whileInView="visible" // Trigger the animation when in view
        viewport={{ once: true }}
      >
        <motion.img
          src={rightImage}
          alt="img"
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 2, ease: "easeInOut" }}
        />
        <motion.div
          className="box2"
          variants={textVariants}
          initial="hidden"
          whileInView="visible" // Scroll-triggered animation
          viewport={{ once: true }}
        >
          <h2>View all upcoming Events</h2>
          <h3>Register now and grow your network</h3>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Minibanners;
